export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/wedding.1e1e434.svg";